interface ImageDimensions {
  width: number;
  height: number;
}

function getImageSize(src: string): Promise<ImageDimensions> {
  const image = new Image();
  return new Promise((resolve) => {
    image.onload = () => {
      resolve({
        width: image.width,
        height: image.height,
      });
    };

    image.src = src;
  });
}

export default getImageSize;
